import { render, staticRenderFns } from "./rfq-list.vue?vue&type=template&id=4308cc8a&scoped=true&"
import script from "./rfq-list.vue?vue&type=script&lang=js&"
export * from "./rfq-list.vue?vue&type=script&lang=js&"
import style0 from "./rfq-list.vue?vue&type=style&index=0&id=4308cc8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4308cc8a",
  null
  
)

export default component.exports